<template>
    <div class="select" :class="opened ? 'opened' : ''">
        <div class="select-input">
            <span
                v-if="placeholderImageUrl"
                class="select-button select-button-image"
                style="
                    background-position: center;
                    background-size: contain;
                    background-repeat: no-repeat;
                    width: 1.5rem;
                    height: 1.5rem;
                    margin-top: 0;
                    margin-bottom: -2px;
                    display: inline-block;
                    margin-left: 1rem;
                    margin-right: -0.5rem;
                "
                :style="{ 'background-image': `url(${placeholderImageUrl})` }"
            ></span>
            <input
                :name="selectInputName"
                class="select-button select-button-input"
                autocomplete="off"
                data-lpignore="true"
                data-form-type="other"
                ref="selectInput"
                v-model="selectInputValue"
                v-on:focus="typing = true"
                :placeholder="this.inputPlaceholderText"
            />
            <input
                type="hidden"
                v-if="hiddenInput"
                :name="selectInputName + '-hidden'"
                v-model="hiddenInputValue"
            />
            <div
                class="select-button select-button-icon"
                @click="dropDownToggle()"
                style="
                    background: #fff
                        url('data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'4\' height=\'5\' viewBox=\'0 0 4 5\'%3e%3cpath fill=\'%23343a40\' d=\'M2 0L0 2h4zm0 5L0 3h4z\'/%3e%3c/svg%3e')
                        no-repeat right 0.75rem center/8px 10px;
                    width: 2rem;
                    height: 100%;
                "
            ></div>
        </div>
        <div class="select-dropdown" v-if="opened">
            <div class="select-dropdown-container">
                <div
                    v-bind:value="option.id"
                    v-for="option in options"
                    v-on:click="select(option)"
                    class="select-option"
                    v-bind:key="option.id"
                >
                    <span
                        v-if="optionImageUrl(option)"
                        style="
                            background-position: center;
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 1.5rem;
                            height: 1rem;
                            margin-top: 3px;
                            margin-bottom: -2px;
                            display: inline-block;
                        "
                        :style="{
                            'background-image': `url(${optionImageUrl(
                                option
                            )})`,
                        }"
                    ></span>
                    <span v-html="optionLabel(option)"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        dropdownContainerId: String,
    },

    data() {
        return {
            options: [],
            opened: false,
            selected: null,
            selectInputValue: '',
            hiddenInput: false,
            hiddenInputValue: '',
            selectHasIcon: false,
            typing: false,
            selectInputName: 'select',
        };
    },

    computed: {
        inputPlaceholderText: function () {},
    },

    watch: {
        typing(value) {
            this.filterOptions();
            this.opened = value;
        },
    },

    mounted() {
        // Avoid dropdown closing if select is put in one
        if (this.dropdownContainerId) {
            let dropdown = this.app.lib.jQuery('#' + this.dropdownContainerId);
            let dropdownMenu = this.app.lib.jQuery(
                '#' + this.dropdownContainerId + ' > .dropdown-menu'
            );
            if (!dropdown.data('select-click-managed')) {
                dropdownMenu.on('click', (event) => {
                    // In case there is a form in the dropdown, submit it
                    if (event.target.type !== 'submit') {
                        dropdown.dropdown('toggle');
                    } else {
                        event.target.form.submit();
                    }
                });
                // Prevent instanciation of on click method several times
                dropdown.data('select-click-managed', true);
            }

            // Helps close the select when clicked outside of it but inside a dropdown
            dropdownMenu.on('click', (event) => {
                this.selectParentClicked(event);
            });
        }

        document.addEventListener('click', (event) => {
            if (!this.$el.contains(event.target)) {
                this.selectParentClicked(event);
            }
        });
    },

    methods: {
        inputFocused() {
            this.typing = true;
            this.dropDownToggle();
        },

        closeSelectDropDown() {
            this.typing = false;
            this.opened = false;
        },

        selectParentClicked(event) {
            // Close the select options if the click is outside of it
            if (
                event.target.id != this.selectInputName &&
                !this.app.lib
                    .jQuery(event.target)
                    .parents('#' + this.selectInputName).length
            ) {
                this.closeSelectDropDown();
            }
        },

        dropDownToggle() {
            if (!this.opened) {
                this.opened = true;
                this.$refs.selectInput.focus();
                this.filterOptions();
            } else {
                this.opened = false;
                this.$refs.selectInput.blur();
            }
        },

        filterOptions() {
            // To override...
        },

        select(option) {
            this.typing = this.opened = false;
        },

        optionLabel(option) {},

        optionImageUrl(option) {
            return false;
        },

        select() {
            this.typing = this.opened = false;
        },
    },

    computed: {
        placeholderImageUrl: function () {},
        inputPlaceholderText: function () {},
    },
};
</script>
